import React, { useEffect, useMemo } from 'react';
import { Modal, Form, Select, TreeSelect, Checkbox, Space, Button, Typography } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { buildAppTreeSelectData } from '../mockData';
import { flattenCategoryOptions } from './categoryTreeUtils';

const { Text } = Typography;

/**
 * 自定义售卖 - 编辑套餐弹窗
 * 编辑：上架 App（必选）/ 售卖区域（国内、海外至少选一）/ 归属分类
 */
const EditSalePackageDialog = ({ open, row, pkgName, categories = [], onCancel, onSave }) => {
    const [form] = Form.useForm();
    const appTreeData = useMemo(() => buildAppTreeSelectData(), []);

    useEffect(() => {
        if (open && row) {
            form.setFieldsValue({
                upApps: row.upApps || [],
                sellRegions: [
                    ...(row.domestic ? ['1'] : []),
                    ...(row.overseas ? ['2'] : []),
                ],
                categoryId: row.categoryId || undefined,
            });
        }
    }, [open, row, form]);

    const handleOk = async () => {
        const values = await form.validateFields();
        onSave(row.id, {
            upApps: values.upApps,
            domestic: (values.sellRegions || []).includes('1'),
            overseas: (values.sellRegions || []).includes('2'),
            categoryId: values.categoryId || null,
        });
    };

    return (
        <Modal
            title="编辑套餐"
            open={open}
            onCancel={onCancel}
            width={520}
            destroyOnClose
            footer={(
                <Space>
                    <Button icon={<CloseOutlined />} onClick={onCancel}>取消</Button>
                    <Button type="primary" icon={<CheckOutlined />} onClick={handleOk}>保存</Button>
                </Space>
            )}
        >
            <Text type="secondary">套餐：{pkgName}</Text>
            <Form form={form} layout="vertical" style={{ marginTop: 12 }}>
                <Form.Item label="上架 App" name="upApps" rules={[{ required: true, message: '请选择上架 App' }]}>
                    <TreeSelect
                        treeData={appTreeData}
                        treeCheckable
                        treeDefaultExpandAll
                        showSearch
                        treeNodeFilterProp="title"
                        showCheckedStrategy={TreeSelect.SHOW_CHILD}
                        placeholder="选择上架 App"
                        maxTagCount="responsive"
                    />
                </Form.Item>
                <Form.Item label="售卖区域" name="sellRegions" rules={[{ required: true, message: '请至少选择一个售卖区域' }]}>
                    <Checkbox.Group options={[{ label: '国内', value: '1' }, { label: '海外', value: '2' }]} />
                </Form.Item>
                <Form.Item label="归属分类" name="categoryId">
                    <Select allowClear placeholder="未分类" options={flattenCategoryOptions(categories)} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditSalePackageDialog;
